import React from 'react';

import { Select, SelectOption } from '@flixbus/honeycomb-react';

import { normalizePageSize, PAGE_SIZE_OPTIONS } from 'pages/CrewTimeline/const';

const PageSizeSelector = ({ fieldControl, submitOnChange }) => {
	const handleOnSelect = (e) => {
		fieldControl.onChange(normalizePageSize(e.target.value));
		submitOnChange();
	};

	return (
		<Select
			id="page-size-selector"
			label="Show items"
			value={fieldControl.value}
			onChange={handleOnSelect}
		>
			{PAGE_SIZE_OPTIONS.map(({ value, label }) => (
				<SelectOption key={value} value={value}>
					{label}
				</SelectOption>
			))}
		</Select>
	);
};

export default PageSizeSelector;
